import { type Static, Type } from '@sinclair/typebox';

export const ArangoMetadataSchema = Type.Object({
  _id: Type.String(),
  _key: Type.String(),
});
export type ArangoDocumentMetadata = Static<typeof ArangoMetadataSchema>;
